import React, { useRef, useEffect, memo } from 'react'
import Highcharts from 'highcharts'
import ReactHighcharts from 'react-highcharts'
import HighchartsReact from 'highcharts-react-official'
import HighchartsMore from 'highcharts/highcharts-more'
import SolidGauge from 'highcharts-solid-gauge'
import styled from 'styled-components'
import Loading from './components/Loading'
import './style.scss'
import { ChartOptions } from './ChartOptions'

HighchartsMore(ReactHighcharts.Highcharts)
SolidGauge(ReactHighcharts.Highcharts)

export const Chart = props => {
    const { loading = true } = props?.state
    if (loading) return <Loading />

    const chartRef = useRef()

    useEffect(() => {
        if (chartRef.current) {
            const { chart } = chartRef.current as {
                chart: Highcharts.Chart
            }
            chart.reflow()
        }
    }, [props.width, props.height])

    
    const Coptions = React.useMemo(() => ChartOptions(props), [props.state, props.widget])
    console.log('render chart')

    return (
        <Container>
            <HighchartsReact
                ref={chartRef}
                constructorType={'chart'}
                highcharts={Highcharts}
                options={Coptions}
            />
        </Container>
    )
}

export default memo(Chart)

const Container = styled.div`
    position: relative;
    width: 100%;
    height: 100%;

    > div:last-child,
    .highcharts-container {
        width: 100% !important;
        height: 100% !important;
    }
`
